module.exports = __webpack_public_path__ + "img/Joboffer.dcec9e17.svg";